import axios from "axios";

const authAPI = axios.create({
  baseURL: "/api/auth",
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 10000,
  withCredentials: true, // Include session cookies
});

// Response interceptor for error handling
authAPI.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      // Extract error message from Django response
      const message =
        error.response.data?.detail ||
        error.response.data?.error ||
        error.response.data?.non_field_errors?.[0] ||
        "An error occurred";

      // Attach user-friendly message to error
      error.userMessage = message;
    } else if (error.request) {
      error.userMessage =
        "No response from server. Please check your connection.";
    } else {
      error.userMessage = "An unexpected error occurred";
    }

    return Promise.reject(error);
  },
);

// Auth operations
export const login = async (email, password) => {
  const response = await authAPI.post("/login/", {
    email,
    password,
  });
  return response.data;
};

export const logout = async () => {
  const response = await authAPI.post("/logout/");
  return response.data;
};

export const register = async (userData) => {
  const { email, password1, password2 } = userData;
  const response = await authAPI.post("/registration/", {
    email,
    password1,
    password2,
  });
  return response.data;
};

export const getCurrentUser = async () => {
  const response = await authAPI.get("/user/");
  return response.data;
};

export const updateProfile = async (userData) => {
  const response = await authAPI.patch("/user/", userData);
  return response.data;
};

// Password operations
export const changePassword = async (
  oldPassword,
  newPassword1,
  newPassword2,
) => {
  const response = await authAPI.post("/password/change/", {
    old_password: oldPassword,
    new_password1: newPassword1,
    new_password2: newPassword2,
  });
  return response.data;
};

export const resetPassword = async (email) => {
  const response = await authAPI.post("/password/reset/", {
    email,
  });
  return response.data;
};

export const confirmPasswordReset = async (
  uid,
  token,
  newPassword,
) => {
  const response = await authAPI.post("/password/reset/confirm/", {
    uid,
    token,
    new_password1: newPassword,
    new_password2: newPassword,
  });
  return response.data;
};

// Email verification operations
export const verifyEmail = async (key) => {
  const response = await authAPI.post("/registration/verify-email/", {
    key,
  });
  return response.data;
};

export const resendVerificationEmail = async (email) => {
  const response = await authAPI.post("/registration/resend-email/", {
    email,
  });
  return response.data;
};

// Pilot claiming operations (for future use)
export const claimPilot = async (pilotId) => {
  const response = await authAPI.post("/claim-pilot/", {
    pilot_id: pilotId,
  });
  return response.data;
};

export const getPilotClaimRequests = async () => {
  const response = await authAPI.get("/pilot-claim-requests/");
  return response.data;
};

export default authAPI;
